import React, { useEffect, useRef, useState } from "react";
import "./VideoPlayer.css";

const VideoPlayer = ({ url, playVideoTrigger, onClose }) => {
  const iframeRef = useRef(null);
  const [player, setPlayer] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Load YouTube IFrame API if not already loaded
    if (!window.YT) {
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      //script.onload = () => initPlayer();
      document.body.appendChild(script);
      window.onYouTubeIframeAPIReady = () => {
        initPlayer();
      };
    } else {
      initPlayer();
    }
  }, []);

  const initPlayer = () => {
    if (iframeRef.current && !player && window.YT && window.YT.Player) {
      const newPlayer = new window.YT.Player(iframeRef.current, {
        events: {
          onReady: () => setPlayer(newPlayer),
          onStateChange: (event) => handleStateChange(event),
        },
      });
    }
  };

  useEffect(() => {
    if (playVideoTrigger && player) {
      setIsExpanded(true);
      player.playVideo();
    }
  }, [playVideoTrigger, player]);

  const handleStateChange = (event) => {
    if (event.data === window.YT.PlayerState.ENDED) {
      collapse(); // Auto-collapse when video ends
    }
  };

  const collapse = () => {
    setIsExpanded(false);
    if (onClose) onClose();
  };

  return (
    <div className={`theater-container ${isExpanded ? "theater-mode" : ""}`}>
      <div className="screening-icon">
        <img
          src="/film.svg"
          alt="Theater Screening Light"
          className="screening-light"
        />
      </div>
      {isExpanded && (
          <button className="close-button" onClick={collapse}>
            Close
          </button>
        )}
      {/* Video frame */}
        <iframe
          ref={iframeRef}
          id="youtube-player"
          width="100%"
          height="100%"
          src={`${url}?enablejsapi=1`} // Ensures API is enabled
          title="Video"
          frameBorder="0"
          allowFullScreen
          allow="autoplay"
        ></iframe>
    </div>
  );
};

export default VideoPlayer;
